import React from 'react'
import { Route, Switch } from 'utils-next/routes'

import { CorporateDetailsView, CorporateListView } from './scenes'
import { CORPORATE_MANAGER_DETAILS_PATH, CORPORATE_MANAGER_LIST_PATH } from './CorporateManager.routes'

export function CorporateManager() {
  return (
    <Switch>
      <Route path={CORPORATE_MANAGER_LIST_PATH} component={CorporateListView} exact />
      <Route path={CORPORATE_MANAGER_DETAILS_PATH} component={CorporateDetailsView} />
    </Switch>
  )
}
